import type { RouterScrollBehavior } from "vue-router";
import { UrlAnchor } from "@/composables/urlAnchor";

export const scrollBehavior: RouterScrollBehavior = (to, from) => {
  const isSameRouteName = to.name === from.name;

  const galleryHash = "#" + UrlAnchor.OpenGallery;
  const isGalleryToggle = to.hash === galleryHash || from.hash === galleryHash;

  if (isSameRouteName && isGalleryToggle) {
    return false; // Do not scroll when open or close gallery
  }

  if (to.hash && document.getElementById(to.hash.slice(1))) {
    // Vue Router computes this via getBoundingClientRect, not scrollIntoView, so it ignores the
    // target's CSS scroll-margin-top — the sticky topbar has to be offset explicitly here too.
    const topbarHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--topbarHeight")) || 0;
    return { el: to.hash, top: topbarHeight + 10 };
  }

  if (isSameRouteName && to.meta.preventScrollToTop === true) {
    return;
  }

  return { top: 0 };
};
